import { formatPrecisaoFloat } from "../../../utils";

export function calculoReajuste(valor, aliquota, operacao, configuracoes) {
  if (!valor) return 0;
  const preco = parseFloat(valor);
  let fator = parseFloat(aliquota || 0);

  if (configuracoes?.margemCalculo === "INVERSA") {
    if (fator > 100) fator = 99.99;
    const result = preco / (1 - fator / 100);
    if (operacao == "subtrair") {
      return formatPrecisaoFloat(2 * preco - result);
    }
    return formatPrecisaoFloat(result);
  } else {
    const result = preco * (1 + fator / 100);
    if (operacao == "subtrair") {
      return formatPrecisaoFloat(2 * preco - result);
    }
    return formatPrecisaoFloat(result);
  }
}

export function calculoLucro(precoVenda, precoCusto, configuracoes) {
  if (!precoCusto || !precoVenda) return 0;
  if (precoVenda <= 0 || precoCusto <= 0) return 0;
  if (configuracoes?.margemCalculo === "INVERSA") {
    const calculoLucroInverso = (1 - precoCusto / precoVenda) * 100;
    const arredondado = Math.ceil(calculoLucroInverso * 100) / 100;
    return formatPrecisaoFloat(arredondado);
  } else {
    const calculoLucroConvencional = ((precoVenda - precoCusto) / precoVenda) * 100;
    const arredondado = Math.ceil(calculoLucroConvencional * 100) / 100;
    return formatPrecisaoFloat(arredondado);
  }
}

export function calculoPrecoVenda(precoCusto, lucro, configuracoes) {
  if (!precoCusto) return 0;
  if (configuracoes?.margemCalculo === "INVERSA") {
    if (lucro > 100) lucro = 99.99;
    const valor = precoCusto / (1 - lucro / 100);
    return formatPrecisaoFloat(valor);
  } else {
    if (lucro >= 100) lucro = 99.99;
    const valor = precoCusto / (1 - lucro / 100);
    return formatPrecisaoFloat(valor);
  }
}